import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["permissionSection"];

  togglePermissions(event) {
    // Find the radio input - event.target could be the label or its children
    const label = event.target.closest("label");
    const input = label?.querySelector("input[type='radio']");

    if (!input) return;

    const isLeadJob = input.value === "true";

    if (isLeadJob) {
      this.permissionSectionTarget.classList.add("hidden");
    } else {
      this.permissionSectionTarget.classList.remove("hidden");
    }
  }
}
